export const LOCAL_STORAGE = {
  USER_AUTH_RBPTRUEBLUE: 'USER_AUTH_RBPTRUEBLUE',
  LANGUAGE_RBPTRUEBLUE: 'LANGUAGE_RBPTRUEBLUE',
  CURRENT_EMAIL: 'CURRENT_EMAIL',
  SELECT_LOCATION_ACCOUNT: 'SELECT_LOCATION_ACCOUNT'
}